// Page de connexion admin : pas de layout (page standalone comme /login)
export default [];
